import { createRoot } from 'react-dom/client';

import App from './App.tsx';
import './styles/index.css';
import { installGTM } from './utils/gtm.ts';

installGTM();

createRoot(document.getElementById('root')!).render(<App />);
